import { Link } from 'react-router-dom';
import { ArrowRight, Check, FileText, Headphones, Languages, Loader2, AlertCircle, Youtube } from 'lucide-react';
import { Step, statusLabel } from './types';
import { languages } from 'data/languages';

function languageLabel(value?: string) {
  if (!value || value === 'original') return value === 'original' ? 'Original language' : '';
  const match = languages.find(language => language.code === value || language.name === value || language.iso === value);
  return match ? `${match.name} (${match.iso.toUpperCase()})` : value;
}
export function WorkflowLine({steps, active}: {steps: Step[]; active?: string}) {
  return <div className="workflow-line">{steps.map((step, i) => {
    const Icon = step.type === 'YouTube' ? Youtube : step.type === 'Voiceover' ? Headphones : step.type === 'Translation' ? Languages : FileText;
    const typeClass = step.type.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    const language = step.language ? languageLabel(step.language) : '';
    const hoverLabel = `${step.label} · ${statusLabel[step.status]}${language ? ` · Language: ${language}` : ''}${step.tag ? ` · ${step.tag}` : ''}`;
    return <div className="workflow-segment" key={step.key}>
      {i > 0 && <ArrowRight className="workflow-arrow" size={18} aria-hidden="true" />}
      <Link to={step.url} className={`workflow-step step-type-${typeClass} ${active === step.key ? 'is-active' : ''}`} aria-current={active === step.key ? 'step' : undefined} title={hoverLabel}>
        <span className={`step-icon ${step.status}`}><Icon size={18}/></span>
        <span className="step-copy"><small>{step.type}</small><strong>{step.label}</strong></span>
        <span className={`step-state ${step.status}`} aria-label={statusLabel[step.status]}>{step.status === 'complete' ? <Check size={14}/> : step.status === 'working' ? <Loader2 size={14} className="animate-spin"/> : step.status === 'needs_attention' ? <AlertCircle size={14}/> : <span>•</span>}</span>
        {step.language && <span className="workflow-tooltip" role="tooltip">Language: {languageLabel(step.language)}{step.tag ? ` · ${step.tag}` : ''}</span>}
      </Link>
    </div>;
  })}</div>;
}
